export default __webpack_public_path__ + "static/media/flyback_async_int_mosfet_ac_psr_neg.18abf13c.svg";